import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { ugcVideoShape, catalogBibShape, shelfItemShape } from '@bibliocommons/bc-prop-types';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import ModalActions from 'app/actions/ModalActions';

import VideoDisplay from './VideoDisplay';

export class VideoDisplayContainer extends React.PureComponent {
  render() {
    return <VideoDisplay {...this.props} />;
  }
}

VideoDisplayContainer.propTypes = {
  // ownProps
  catalogBib: catalogBibShape.isRequired,
  displayStaffBadge: PropTypes.bool,
  handleDeleteSuccess: PropTypes.func,
  video: ugcVideoShape.isRequired,

  // Redux props
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfItem: shelfItemShape
};

const mapStateToProps = (state, ownProps) => ({
  author: selectUserEntities(state).get(ownProps.video.get('userId').toString(), Immutable.Map()),
  shelfItem: selectShelvesForCurrentUser(state).get(ownProps.catalogBib.get('metadataId'))
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoDisplayContainer);
